import config from 'utils/config';
export var isHelixOnlyHub = config.helixIntegrationMode === 'helix';